import {
  getBasePath,
  setBasePath
} from "../chunks/chunk.3Y6SB6QS.js";
import "../chunks/chunk.KAW7D32O.js";
export {
  getBasePath,
  setBasePath
};
